import { getOrganisations } from 'entities/organisations/api/getOrganisations'
import { getOrganisationById } from 'entities/organisations/api/getOrganisationById'

export const OrganisationsApi = {
    getOrganisations,
    getOrganisationById,
}
